import loadable from 'utils/loadable'

const Loadable = loadable(() => import('./index'))

export default Loadable
